import { utils } from '@ps/web-poker-tile-mappers';
import classNames from 'clsx';
import React from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import { numberFormatter } from '../../../../utils/numbers';
import styles from '../shared.scss';

interface PrizeProps {
  currency: number;
  value?: number | string;
  className?: string;
  star?: boolean;
  isCurrency?: boolean;
}

const Prize: React.FC<PrizeProps> = ({ currency, value, className, star, isCurrency = false }) => {
  const isPlayMoney = useSelector(select.currency.isPlayMoney);
  const locale = useSelector(select.locale.get);

  if (!value) return <td className={className} />;

  // Play money and promo
  if (typeof value !== 'number') return <td className={className}>{value}</td>;

  // format for multiplier and probability
  if (!isCurrency) return <td className={className}>{numberFormatter({ value })}</td>;

  return (
    <td className={classNames('prize-distribution-table-cell', className)}>
      {utils.formatCurrency(value, currency, {
        shorten: true,
        shortenRM: true,
        separators: true,
        isPlayMoney: isPlayMoney ? 1 : 0,
        locale,
        scalePM: 1
      })}
      {star ? ' *' : null}
    </td>
  );
};

export default Prize;
